import React from 'react';

export default function BlueCollarSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Collar band */}
      <path d="M6 18C6 18 10 24 20 24C30 24 34 18 34 18" stroke="#3366AA" strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* Collar inner highlight */}
      <path d="M8 18C8 18 12 23 20 23C28 23 32 18 32 18" stroke="#4488CC" strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Buckle */}
      <rect x="18" y="22" width="4" height="4" rx="0.5" fill="#C0C0C0" stroke="#A0A0A0" strokeWidth="0.5" />
      <rect x="19.5" y="23" width="1" height="2" fill="#A0A0A0" />
      {/* Tag */}
      <circle cx="20" cy="30" r="4" fill="#C0C0C0" />
      <circle cx="20" cy="30" r="3" fill="#D8D8D8" />
      {/* Tag ring */}
      <circle cx="20" cy="26" r="1.5" stroke="#A0A0A0" strokeWidth="0.8" fill="none" />
      {/* Tag engraving */}
      <circle cx="20" cy="30" r="1.5" fill="#A0A0A0" opacity="0.5" />
    </svg>
  );
}
